module.exports = __webpack_public_path__ + "media/images/responsive/flow/resort_visit_step_02-ef6faaedf029e2dd7ed68b155169b3d8.jpg";